import script from "./ExclusionCustomForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclusionCustomForm.vue?vue&type=script&setup=true&lang=js"

import "./ExclusionCustomForm.vue?vue&type=style&index=0&id=74af92d5&lang=css"

const __exports__ = script;

export default __exports__